<form method="POST" action="/login?/logout">
	<button class="btn variant-filled-primary">Logout</button>
</form>
